export default __webpack_public_path__ + "static/media/loading-9.e28aea36.gif";